module.exports = __webpack_public_path__ + "img/credential5.8ecd0cdd.png";